import { useEffect } from 'react';

export const useTitle = (title: string | null) => {
  useEffect(() => {
    // Set a default title if the provided title is empty or null
    document.title = title || '1Advisor';
  }, [title]);
};
